
<script>
export default {
  name: 'rex-text',
  props: {
    label: {
      type: String,
      default: () => null
    },
    name: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      default: () => null
    },
    data: {
      type: [String, Number],
      default: () => null
    },
    storeModule: {
      type: String,
      default: () => null,
      required: true
    },
    getterName: {
      type: String,
      default: () => null,
      required: true
    },
    setterName: {
      type: String,
      default: () => null,
      required: true
    },
    target: {
      type: String,
      default: () => null,
      required: true
    },
    cssClass: {
      type: String,
      default: () => null
    },
    baseCssClass: {
      type: String,
      default: () => 'rex-input'
    },
    disabled: {
      type: Boolean,
      default: () => false
    },
    showLabel: {
      type: Boolean,
      default: () => true
    },
    uppercase: {
      type: Boolean,
      default: () => false
    },
    type: {
      type: String,
      default: () => 'text'
    },
    validate: {
      type: [String, Object],
      default: () => null
    },
  },
  inject: ['$validator'],
  computed: {
    value: {
      get() {
        return this.$store.getters[`${this.storeModule}/${this.getterName}`](this.target)
      },
      set(value) {
        let data = this.uppercase ? value.toUpperCase() : value

        data = this.type === 'number' ? Number(data) : data

        this.$store.commit(`${this.storeModule}/${this.setterName}`, {
          target: this.target,
          value: data
        })

        if (this.error !== null) {
          const target = this.target.split('.')
          const err = this.$store.getters[`${this.storeModule}/${this.getterName}`](`${target[0]}Errors`)
          const currentFieldErrorIndex = err.map(x => x.field).indexOf(this.name)

          err.splice(currentFieldErrorIndex, 1)

          this.$store.commit(`${this.storeModule}/${this.setterName}`, err)
        }

        this.$emit('onChange', data)
      }
    },
    error() {
      const target = this.target.split('.')
      const err = this.$store.getters[`${this.storeModule}/${this.getterName}`](`${target[0]}Errors`)
        .find(error => error.field === this.name)

      return err ? err.message : null
    }
  },
}
</script>

<template>
  <div
    :class="cssClass"
    class="rex-field rex-field__input"
  >
    <h3
      v-if="showLabel"
      class="rex-field--label"
    >
      {{ label }}
    </h3>
    <b-field
      :type="{'is-danger': errors.has(name) || error}"
      :message="errors.first(name) || error"
    >
      <b-input
        v-if="data"
        v-validate="validate"
        :value="data"
        :name="name"
        :placeholder="placeholder"
        :disabled="disabled"
        :type="type"
        :class="[
          baseCssClass,
          { disabled: disabled },
          { 'rex-input__uppercase': uppercase }
        ]"
      />
      <b-input
        v-else
        v-model="value"
        v-validate="validate"
        :name="name"
        :placeholder="placeholder"
        :disabled="disabled"
        :type="type"
        :class="[
          baseCssClass,
          { disabled: disabled },
          { 'rex-input__uppercase': uppercase }
        ]"
      />
    </b-field>
  </div>
</template>
